import { React, RefObject } from "react";
import {
  Form,
  Input,
  Button,
  Dialog,
  TextArea,
  Selector,
  Slider,
  Stepper,
  Switch,
  SafeArea
} from "antd-mobile";
import styles from "./Add.module.css"
import AddFilter from "./AddFilter.js"
import "./Adm.css"

const states = require("../../../utils/states.js")


const marks = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5
}


//props.submit(gramma)  gramma 为null则取消,gramma为非null则提交
export default (props) => {
  const onFinish = (values) => {
    if (!values.level) values.level = 1
    // const gramma = JSON.stringify(values, null, 2)
    const gramma = values
    console.log(gramma)
    props.submit(gramma)
  }

  const onCanceled = () => {
    props.submit(null)
  }
  const initLists = (wrap) => {
    wrap.listAdd = []
    var totalC = wrap.list.length
    for (let i = 1; i < totalC; i++) {
      let item = wrap.list[i]
      wrap.listAdd.push({ key: i - 1, name: item.name, selected: false })
    }
  }
  console.log('清空新建tag列表')
  initLists(states.rootTagsWrap)
  initLists(states.prepTagsWrap)
  initLists(states.formTagsWrap)

  return (<div className={styles.addGramma}>

    <Form mode='card' className={styles.addForm}
      onFinish={onFinish}
      layout='horizontal'
      footer={<div style={{ display: 'flex' }}>
        <Button style={{ 'flex': 1, 'marginRight': '5px' }} size='large' onClick={onCanceled}>
          取消</Button>
        <Button style={{ 'flex': 1, 'marginLeft': '5px' }}
          type='submit' color='primary' size='large'>
          提交</Button>
      </div>
      }
    >
      <div className={styles.formList}>
        <Form.Header>添加一条Gramma</Form.Header>
        <Form.Item name='left_col' label='左侧'>
          <Input placeholder='左侧接续' />
        </Form.Item>
        <Form.Item name='gramma' label='语法'
          rules={[{ required: true, message: '语法不能为空' }]}>
          <Input placeholder='核心语法' />
        </Form.Item>
        <Form.Item name='right_col' label='右侧'>
          <Input placeholder='右侧接续' />
        </Form.Item>
        <Form.Item name='definition' label='解释'>
          <TextArea
            placeholder='请输入解释'
            maxLength={50}
            rows={2}
            showCount
          />
        </Form.Item>
        <Form.Item name='note' label='笔记'>
          <TextArea
            placeholder='笔记区域'
            maxLength={100}
            rows={2}
            showCount
          />
        </Form.Item>
        <Form.Item name='level' label='等级'>
          <Slider style={{ '--fill-color': 'var(--adm-color-default)' }} marks={marks} ticks step={1} min={1} max={5} popover />
        </Form.Item>

        <div name='root' label='词根' style={{ padding: '15px' }}>
          词根
          <AddFilter listShell={states.rootTagsWrap} />
        </div>
        <div name='prep' label='介词' style={{ padding: '15px' }}>
          介词
          <AddFilter listShell={states.prepTagsWrap} />
        </div>
        <div name='form' label='语态' style={{ padding: '15px' }}>
          语态
          <AddFilter listShell={states.formTagsWrap} />
        </div>
      </div>
    </Form>


  </div>)
}